import { render, staticRenderFns } from "./wuliaoDetail.vue?vue&type=template&id=5185ca93&scoped=true&"
import script from "./wuliaoDetail.vue?vue&type=script&lang=js&"
export * from "./wuliaoDetail.vue?vue&type=script&lang=js&"
import style0 from "./wuliaoDetail.vue?vue&type=style&index=0&id=5185ca93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185ca93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5185ca93')) {
      api.createRecord('5185ca93', component.options)
    } else {
      api.reload('5185ca93', component.options)
    }
    module.hot.accept("./wuliaoDetail.vue?vue&type=template&id=5185ca93&scoped=true&", function () {
      api.rerender('5185ca93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/selldetails/wuliaoDetail.vue"
export default component.exports